import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

interface IProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

const UploadFormSection = ({
  className,
  title,
  subtitle,
  children,
}: PropsWithChildren<IProps>) => {
  return (
    <section
      className={twMerge(
        className,
        'flex flex-col items-stretch gap-3 md:gap-6 bg-white p-0 lg:p-8 rounded-2xl lg:border border-secondary-100'
      )}
    >
      {title || subtitle ? (
        <div className="flex flex-col items-stretch gap-1">
          {title ? (
            <p className="text-lg text-mobile-gray-600 font-semibold leading-[150%]">
              {title}
            </p>
          ) : null}
          {subtitle ? (
            <p className="text-sm text-mobile-gray-500 leading-[160%]">
              {subtitle}
            </p>
          ) : null}
        </div>
      ) : null}
      {children}
    </section>
  );
};

export default UploadFormSection;
